export const fonts = {
    roboto: 'RobotoCondensed-Regular',
    robotoBold: 'RobotoCondensed-Bold',
    robotoItalic: 'roboto_condensed_italic',
    flameBold: 'Flame Bold',
    flameRegular: 'Flame Regular',
    flameSansRegular: 'Flame Sans Regular'
}
